import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const MenuClient = () => {
  const location = useLocation();

  const links = [
    { path: '/banque/portefeuille', label: 'Portefeuille', icon: '🏦' },
    { path: '/banque/virement', label: 'Virement', icon: '💸' },
    { path: '/banque/carte', label: 'Carte', icon: '💳' },
    { path: '/banque/compte', label: 'Compte', icon: '👤' },
  ];

  return (
    <nav style={styles.menu}>
      {links.map((item) => {
        const isActive = location.pathname === item.path;
        return (
          <Link
            key={item.path}
            to={item.path}
            style={{
              ...styles.link,
              color: isActive ? '#FFFFFF' : '#94A3B8',
            }}
          >
            <div style={styles.icon}>{item.icon}</div>
            <div style={styles.label}>{item.label}</div>
          </Link>
        );
      })}
    </nav>
  );
};

const styles = {
  menu: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: '#1E293B', // bluegray-800
    padding: '10px 0',
    borderTop: '1px solid #94A3B8', // bluegray-400
    zIndex: 1000,
  },
  link: {
    textDecoration: 'none',
    textAlign: 'center',
    fontSize: '12px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2px',
    fontWeight: '500',
    width: '25%',
  },
  icon: {
    fontSize: '20px',
  },
  label: {
    fontSize: '11px',
  },
};

export default MenuClient;
